import React from "react";

// A slick, discrete fingerprint touch hint shown over each steering zone, tinted
// the player's worm colour ("press here"). Rests faint, glows in the worm colour
// on touch. For player 2 (sitting on the opposite side of the phone) it's flipped
// 180° so it reads right-way-up from their side. Positioned (by the overlay) just
// off the game board's top/bottom edge - left/right is conveyed by which side it
// sits on, so no arrow is needed.
//
// Fingerprint ridge paths are the Lucide "fingerprint" icon (ISC licensed).
const FINGERPRINT_PATHS = [
  "M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4",
  "M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2",
  "M17.29 21.02c.12-.6.43-2.3.5-3.02",
  "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
  "M8.65 22c.21-.66.45-1.32.57-2",
  "M14 13.12c0 2.38 0 6.38-1 8.88",
  "M2 16h.01",
  "M21.8 16c.2-2 .131-5.354 0-6",
  "M9 6.8a6 6 0 0 1 9 3.2c0 .6 0 1.3-.2 2",
];

interface Props {
  color: string;
  flip?: boolean;
  pressed?: boolean;
}

export default function TouchFingerprint({ color, flip, pressed }: Props) {
  return (
    <div
      className={"touch-thumb" + (pressed ? " is-pressed" : "")}
      style={{ color, transform: flip ? "rotate(180deg)" : undefined }}
      aria-hidden="true"
    >
      <svg
        className="touch-thumb-print"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable="false"
      >
        {FINGERPRINT_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </svg>
    </div>
  );
}
